import {
    SiTypescript,
    SiReact,
    SiRedux,
    SiExpress,
    SiNodedotjs,
    SiMongodb,
    SiSolidity,
    SiBlockchaindotcom,
    SiBootstrap,
    SiSass,
} from 'react-icons/si';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaGithub } from 'react-icons/fa';
import { LinkOutlined } from '@ant-design/icons';

import { Python } from './svgs/svgs';

const Icons = {
    typescript: SiTypescript,
    react: SiReact,
    redux: SiRedux,
    express: SiExpress,
    node: SiNodedotjs,
    mongodb: SiMongodb,
    solidity: SiSolidity,
    blockchain: SiBlockchaindotcom,
    python: Python,
    bootstrap: SiBootstrap,
    scss: SiSass,
    facebook: FaFacebookF,
    twitter: FaTwitter,
    linkedin: FaLinkedinIn,
    github: FaGithub,
    link: LinkOutlined,
};

export default Icons;
